// Port of api/fuel/app/classes/insights/ratings/activity.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import Insight from 'offline/model/insight'

export default Segment.extend({
    name: 'activity',
    priority: 1,
    default_: true,
    requires: [],
    insight: false,
    detail: false,
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_ratings()) return {}

        var activity = []

        var currentMonth = Util.time()

        var added = Insight.collection({
            where: {
                user_id: (type === Constants.TYPE_USER) ? owner.get_id() : 0,
                group_id: (type === Constants.TYPE_GROUP) ? owner.get_id() : 0,
                buddies_id: (type === Constants.TYPE_BUDDIES) ? owner.get_id() : 0,
                insight_type: Constants.INSIGHT_TYPE_RATINGS_ADDED,
                insight_period: Constants.INSIGHT_PERIOD_MONTH
            },
            order_by: 'insight_date DESC',
            limit: 12
        }).associated('insight_stamp')

        var updated = Insight.collection({
            where: {
                user_id: (type === Constants.TYPE_USER) ? owner.get_id() : 0,
                group_id: (type === Constants.TYPE_GROUP) ? owner.get_id() : 0,
                buddies_id: (type === Constants.TYPE_BUDDIES) ? owner.get_id() : 0,
                insight_type: Constants.INSIGHT_TYPE_RATINGS_UPDATED,
                insight_period: Constants.INSIGHT_PERIOD_MONTH
            },
            order_by: 'insight_date DESC',
            limit: 12
        }).associated('insight_stamp')

        var total = Insight.collection({
            where: {
                user_id: (type === Constants.TYPE_USER) ? owner.get_id() : 0,
                group_id: (type === Constants.TYPE_GROUP) ? owner.get_id() : 0,
                buddies_id: (type === Constants.TYPE_BUDDIES) ? owner.get_id() : 0,
                insight_type: Constants.INSIGHT_TYPE_RATINGS_COUNT,
                insight_period: Constants.INSIGHT_PERIOD_MONTH
            },
            order_by: 'insight_date DESC',
            limit: 12
        }).associated('insight_stamp')

        for (var i = 12; i >= 1; i--) {

            var stamp = Util.date('m.y', currentMonth)

            if (total[stamp]) {

                activity.push({
                    month: Util.date('m/y', currentMonth),
                    total: total[stamp] ? parseInt(total[stamp].get_insight_value(), 10) : 0,
                    added: added[stamp] ? parseInt(added[stamp].get_insight_value(), 10) : 0,
                    updated: updated[stamp] ? parseInt(updated[stamp].get_insight_value(), 10) : 0
                })

            }

            currentMonth = Util.mktime(0, 0, 0, [1, parseInt(Util.date('c', currentMonth), 10) - 1, parseInt(Util.date('Y', currentMonth), 10)])

        }

        activity.reverse()

        return {
            activity: activity
        }

    }
})
